/**
 * External dependencies
 */
import { Reducer } from 'redux';

/**
 * Internal dependencies
 */
import { Route } from '@/router';
import { setRoutes, setPrevRoute } from '@/store/actions';
import initialState from '../../initialState';
import isAction from '../../isAction';

const prevRoute: Reducer<Route | null> = (
	state = initialState.router.prevRoute,
	action
) =>
	isAction(action, setPrevRoute)
		? action.payload
		: isAction(action, setRoutes)
			? (action.payload.prev ?? state)
			: state;

export default prevRoute;
